import React, { useState } from 'react'
import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material'
import { ExpandMore, HelpOutline } from '@mui/icons-material'

const FAQ = ({ companyData }) => {
  const { faqs } = companyData || {}
  const [expanded, setExpanded] = useState(false)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  return (
    <Container maxWidth='md' sx={{ py: { xs: 6, md: 8 } }}>
      <Box sx={{ mb: 8, textAlign: 'center' }}>
        <Typography variant='h3' gutterBottom color='primary.main' sx={{ mb: 2 }}>
          Frequently Asked Questions
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ fontSize: '1.1rem' }}>
          Find answers to common questions about our services and group bookings
        </Typography>
      </Box>

      {faqs && faqs.length > 0 ? (
        <Box>
          {faqs.map((faq, index) => (
            <Accordion
              key={faq.id}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              sx={{
                mb: 2,
                '&:before': { display: 'none' },
                boxShadow: 1,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{
                  '&.Mui-expanded': {
                    bgcolor: 'primary.light',
                    color: 'white',
                  },
                }}
              >
                <Typography variant='h6'>{faq.question}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ pt: 3 }}>
                <Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <HelpOutline sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant='h6' color='text.secondary'>
            No FAQs available at the moment
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          mt: 6,
          p: 3,
          bgcolor: 'primary.light',
          color: 'white',
          borderRadius: 2,
          textAlign: 'center',
        }}
      >
        <Typography variant='h6' gutterBottom>
          Still have questions?
        </Typography>
        <Typography variant='body1'>
          Don't hesitate to contact us directly. We're here to help!
        </Typography>
      </Box>
    </Container>
  )
}

export default FAQ
